module.exports = __webpack_public_path__ + "img/fondomenu1.913ea691.jpg";